import update from "immutability-helper";

import {
  REQUEST_PROFILES,
  RECEIVE_PROFILES,
  FAILED_FETCH_PROFILES,
  SET_FILTERS,
  SET_PROFILES_LOV,
} from "../constants/actionTypes";

const profiles = (state = {}, action) => {
  switch (action.type) {
    case REQUEST_PROFILES:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_PROFILES:
      return {
        ...state,
        isFetching: false,
        profiles: action.profiles,
      };
    case FAILED_FETCH_PROFILES:
      return {
        ...state,
        isFetching: false,
        error: "failedToFetchProfiles",
      };
    case SET_PROFILES_LOV:
      return {
        ...state,
        lov: action.lov,
      };
    case SET_FILTERS:
      return update(state, {
        filters: { $set: action.payload },
      });
    default:
      return state;
  }
};

export default profiles;
